// Mancala page entry.
import { MancalaGame } from "../board/mancala-ui"

const root = document.getElementById("board")
if (root) (window as unknown as { dtGame?: MancalaGame }).dtGame = new MancalaGame(root)
